
import {
    HeroCheckCircleIconSolid, HeroMinusIcon, HeroPlusIcon,
} from 'components/Icon'

import {
    InviteesTemplateItem,
    MultiselectTemplateItem, SearchAutocompleteItem,
    SearchBasicTemplateItem,
} from '../types'

import {
    inviteesNameWrapper, inviteesWrapper,
    multiselectIconWrapper, multiselectSelectedIconWrapper,
    searchBasicActionWrapper, searchBasicWrapper, timezoneWrapper,
} from '../styles/templates.styles'

import LetterAvatar from 'components/Avatar/LetterAvatar'
import React from 'react'
import User from 'components/User'

import {styled} from 'stitches/config'

const StyledSearchBasicWrapper = styled('div', searchBasicWrapper)
const StyledSearchBasicActionWrapper = styled('div', searchBasicActionWrapper)
const StyledTimezoneWrapper = styled('div', timezoneWrapper)
const StyledTranscriptSearchKey = styled('div', {whiteSpace: 'nowrap'})


export const SearchBasicTemplate = ({
    name, content, action,
}: SearchBasicTemplateItem) => (
    <StyledSearchBasicWrapper>
        <div data-id='autocompleteName'>{name}</div><div data-id='autocompleteContent'>{content}</div><div data-id='autocompleteAction'>{action}</div>
    </StyledSearchBasicWrapper>
)

export const LanguageSearchTemplate: React.FC<SearchAutocompleteItem> = ({
    name,
    code,
    action,
}) => (
    <StyledSearchBasicWrapper>
        <div>{code}</div><div>{name}</div><div>{action}</div>
    </StyledSearchBasicWrapper>
)

export const TranscriptSearchTemplate = ({
    name, action,
}: SearchBasicTemplateItem) => (
    <StyledSearchBasicActionWrapper>
        {!!action && <div>{action}</div>}<StyledTranscriptSearchKey>{name}</StyledTranscriptSearchKey>
    </StyledSearchBasicActionWrapper>
)

const StyledMultiselectIconWrapper = styled('div', multiselectIconWrapper)
export const StyledMultiselectSelectedIconWrapper = styled('div', multiselectSelectedIconWrapper)

export const MultiselectTemplate = ({
    name, content, selected = false,
}: MultiselectTemplateItem) => (
    <StyledSearchBasicWrapper>
        <div>{name}</div><div>{content}</div>
        <StyledMultiselectIconWrapper>
            {selected ?
                <StyledMultiselectSelectedIconWrapper>
                    <HeroCheckCircleIconSolid size={16} />
                    <HeroMinusIcon size={16} />
                </StyledMultiselectSelectedIconWrapper>
                : <HeroPlusIcon size={16} />}
        </StyledMultiselectIconWrapper>
    </StyledSearchBasicWrapper>
)


const StyledInviteesWrapper = styled('div', inviteesWrapper)
const StyledInviteesNameWrapper = styled('div', inviteesNameWrapper)

export const InviteesTemplate = ({
    name, realName, action, title, company, id,
}: InviteesTemplateItem) => (
    <StyledInviteesWrapper>
        <div>
            {id ?
                <User avatarOnly={true} userId={id} />
                : <LetterAvatar name={name} />}
        </div>
        <StyledInviteesNameWrapper>
            <div>{name}</div>
            <div>{`${realName || ' '}
                    ${title ? `,${title}` : ' '}
                    ${company ? `,${company}` : ' '}`}
            </div>
        </StyledInviteesNameWrapper>
        <div>{action}</div>
    </StyledInviteesWrapper>
)

export const TimezoneTemplate = ({
    content, name,
}: SearchBasicTemplateItem) => (
    <StyledTimezoneWrapper>
        <div>{name}</div><div>{content}</div>
    </StyledTimezoneWrapper>
)
